const PlaceModule = {
  namespaced: true,
  state: {
    countrys: [],
    regions: [],
    provinces: [],
    districts: [],
    subdistricts: []
  },
  mutations: {
    FETCH_COUNTRY(state, payload) {
      state.countrys = []
      state.countrys = payload
    },
    FETCH_REGION(state, payload) {
      state.regions = []
      state.regions = payload
    },
    FETCH_PROVINCE(state, payload) {
      state.provinces = []
      state.provinces = payload
    },
    FETCH_DISTRICT(state, payload) {
      state.districts = []
      state.districts = payload
    },
    FETCH_SUBDISTRICT(state, payload) {
      state.subdistricts = []
      state.subdistricts = payload
    }
  },
  actions: {
    async fetchCountry({ commit }) {
      try {
        const response = await axios.get(`/country/get`)
        commit('FETCH_COUNTRY', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchRegion({ commit }) {
      try {
        const response = await axios.get(`/region/get`)
        commit('FETCH_REGION', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchProvince({ commit }) {
      try {
        const response = await axios.get(`/province/get`)
        commit('FETCH_PROVINCE', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchDistrict({ commit }) {
      try {
        const response = await axios.get(`/district/get`)
        commit('FETCH_DISTRICT', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchSubDistrict({ commit }) {
      try {
        const response = await axios.get(`/subdistrict/get`)
        commit('FETCH_SUBDISTRICT', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getCountryAll: state => {
      return state.countrys
    },
    getRegionAll: state => {
      return state.regions
    },
    getProvinceAll: state => {
      return state.provinces
    },
    getDistrictAll: state => {
      return state.districts
    },
    getSubDistrictAll: state => {
      return state.subdistricts
    }
  }
}

export default PlaceModule



// WEBPACK FOOTER //
// ./src/store/modules/place.js